<template>
  <div class="hideOnScroll filter" ref="hideOnScroll">
    <p-vue-input-text
      type="text"
      class="phone-number search"
      v-model="search"
      :placeholder="__('search')"
    />
    <p-vue-button
      :label="__('Price per kWh')"
      class="p-button-rounded p-button-success p-mr-2"
      @click="showModalbyType(2, __('Price definition per kWh'))"
    />
  </div>

  <div v-if="kWhPrice && kWhPrice > 0">
    <div v-if="allMeters.length == 0" class="no-kWhPrice p-p-4">
      {{
        __(
          'No charging stations have been set in this building, click "New Charging Station" to set up'
        )
      }}
    </div>
    <local-meter
      v-else
      v-for="(meter, index) of MetersFilterd"
      :key="index"
      :meter="meter"
      :commision="commisionData"
      :BID="BID"
      @refreshAllMeters="getData"
    ></local-meter>
  </div>
  <div v-else class="p-d-flex p-flex-column p-ai-center p-p-4">
    <div class="no-kWhPrice">
      {{
        __(
          "No price has been set for this building. A price must be set before adding charging stations"
        )
      }}
      <a
        class="definition"
        @click="showModalbyType(2, __('Price definition per kWh'))"
      >
        {{ __("definition") }}</a
      >
    </div>
  </div>

  <i-plus-button
    v-if="kWhPrice > 0"
    @click="showModalbyType(1, __('Adding a counter'))"
    :text="__('New charging station')"
  />
  <i-override-dialog
    v-model:visible="showModal"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :dismissableMask="true"
    :title="modelTitle"
  >
    <local-add-electricity-meter
      v-if="showModal == 1"
      :BID="BID"
      :meter="{}"
      :close="() => (showModal = null)"
      @refreshAllMeters="getData"
    ></local-add-electricity-meter>
    <local-add-kWhPrice
      v-if="showModal == 2"
      :BID="BID"
      :kWhPrice="kWhPrice"
      @refreshAllMeters="getData"
      :close="() => (showModal = null)"
    ></local-add-kWhPrice>
  </i-override-dialog>
</template>

<script>
import LocalAddElectricityMeter from "./add-electricity-meter";
import LocalAddKWhPrice from "./add-kWhPrice";
import LocalMeter from "./meter";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { errorReceived } from "@/services/apointUtil";
// import { __ } from "@/plugins/i18n/";

export default {
  components: {
    LocalAddElectricityMeter,
    LocalAddKWhPrice,
    LocalMeter,
  },
  data() {
    return {
      showModal: null,
      modelTitle: "",
      BID: this.$route.params.bid,
      allMeters: [],
      search: null,
      commisionData: null,
      kWhPrice: 0,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("BID", this.BID, apiPType.Int)];
      callProc("WorkerApp_GetMeterSToBuilding", procParams)
        .then((result) => {
          this.$store.dispatch("doLoading", false);
          result = JSON.parse(result);
          // console.log(result);
          this.allMeters = result.Table;
          this.kWhPrice = result.Table1[0].kWhPrice;
          this.commisionData = result.Table2[0];
        })
        .catch(() => {
          errorReceived("WorkerApp_GetMeterSToBuilding");
        });
    },
    showModalbyType(type, title) {
      this.showModal = type;
      this.modelTitle = title;
    },
  },
  computed: {
    MetersFilterd() {
      return this.allMeters.filter(
        (f) =>
          !this.search ||
          f.MeterNum.includes(this.search) ||
          f.Number.includes(this.search)
      );
    },
  },
};
</script>

<style scoped>
.filter {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  background-color: var(--color-primary);
}

.filter a {
  color: white;
  margin-right: 3px;
}

.filter a:deep(.svg) {
  width: 24px;
  height: 24px;
}

.search {
  flex: 1;

  padding: 0 0 8px 0;

  border-radius: 0;
  border: 1px solid white;
  border-width: 0 0 1px 0;
  background-color: transparent;

  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.search::placeholder {
  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.definition {
  text-decoration: underline;
}

.no-kWhPrice {
  font-size: 18px;
}
</style>
